var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "searchDom",
    staticClass: "container hot-click-area",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "search-icon"
  }), _c('div', {
    staticClass: "search-title"
  }, [_vm._v(_vm._s(_vm.recommendInfo.title) + _vm._s(_vm.recommendTitle()))]), _c('div', {
    staticClass: "more-icon"
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };